var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.017 6.86265C35.6864 6.53358 35.2717 6.30225 34.8185 6.19408C34.3653 6.08591 33.8912 6.10508 33.4481 6.24948L7.88134 14.7987C7.40718 14.9494 6.98817 15.2375 6.67725 15.6267C6.36633 16.0159 6.17744 16.4887 6.13443 16.9855C6.09142 17.4823 6.19622 17.9807 6.43561 18.4177C6.67499 18.8548 7.03822 19.211 7.4794 19.4413L18.0871 24.6969L23.3297 35.366C23.5405 35.7836 23.8629 36.1342 24.261 36.3786C24.6592 36.623 25.1173 36.7516 25.5841 36.75H25.7589C26.2588 36.7131 26.7362 36.5263 27.1288 36.2138C27.5215 35.9014 27.8114 35.4778 27.9608 34.9981L36.6112 9.43793C36.7657 8.99634 36.7918 8.51984 36.6866 8.06392C36.5814 7.60799 36.3492 7.1914 36.017 6.86265ZM8.96483 17.2163L31.2811 9.75328L18.891 22.1742L8.96483 17.2163ZM25.7064 33.982L20.7434 24.0312L33.1336 11.6103L25.7064 33.982Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatIcon);
export default __webpack_public_path__ + "static/media/sendChatIcon.f971fc024a3ae5a5562b2ba53e1e4883.svg";
export { ForwardRef as ReactComponent };